import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElmComponent } from './simple-icons-elm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElmComponent ],
    exports:      [ SimpleIconsElmComponent ],
    bootstrap:    []
})
export class SimpleIconsElmModule {}
